import React, { useEffect, useState } from "react";
import axios from "axios";
import GitHubButton from "react-github-btn";

const MiniProjects = () => {
  const [projects, setProjects] = useState([{}]);
  const [technologies, setTechnologies] = useState([{}]);
  const [selectedFilter, setselectedFilter] = useState("");

  useEffect(() => {
    const getPiaRepos = async () => {
      const res = await axios.get(
        "https://api.github.com/users/Kartik18g/repos?per_page=100&type=owner",
        { headers: { Accept: "application/vnd.github.mercy-preview+json" } }
      );
      var reposWithTopics = [];
      var technologies = [{ name: "All", filter: "" }];
      res.data.forEach((project) => {
        if (project.topics.length > 0) {
          reposWithTopics.push(filterData(project));
          var { topics } = project;
          topics.forEach((topic) => {
            if (
              !JSON.stringify(technologies).includes(
                JSON.stringify({
                  name: topic.charAt(0).toUpperCase() + topic.slice(1),
                  filter: topic,
                })
              )
            ) {
              technologies.push({
                name: topic.charAt(0).toUpperCase() + topic.slice(1),
                filter: topic,
              });
            }
          });
        }
      });
      setProjects(reposWithTopics);

      setTechnologies(technologies);
    };
    getPiaRepos();
  }, []);

  const filterData = (data) => {
    const { name, topics, homepage, html_url, description } = data;
    return { name, topics, homepage, url: html_url, description };
  };
  const filterButtons = Array.prototype.slice.call(
    document.querySelectorAll(".filter-button")
  );

  useEffect(() => {});

  const [prevButton, setprevButton] = useState("");
  const handleFilter = (e) => {
    filterButtons.map((button) => button.classList.remove("active-filter"));
    const type = e.target.getAttribute("data-filter");
    setselectedFilter(e.target.getAttribute("data-filter"));
    e.target.classList.add("active-filter");
  };
  console.log(selectedFilter);

  // const technologies = [
  //   { name: "All", filter: "" },
  //   { name: "React", filter: "react" },
  //   { name: "Firebase", filter: "firebase" },
  //   { name: "Bootstrap", filter: "bootstrap" },
  //   { name: "MongoDB", filter: "mongodb" },
  //   { name: "GraphQL", filter: "graphql" },
  //   { name: "Hasuka", filter: "hasuka" },
  // ];

  const classFunction = (technologies) => {
    var cName = "project";
    technologies &&
      technologies.forEach((t) => {
        cName = cName + " " + t;
      });
    return cName;
  };

  return (
    <section style={{ minHeight: "auto" }} className="mini-projects">
      <div className="container">
        {technologies.length > 0 ? (
          <div className="project-filter-buttons">
            {technologies &&
              technologies.map((t, index) => {
                return (
                  <button
                    id={`button-${index + 1}`}
                    onClick={(e) => {
                      handleFilter(e);
                      setprevButton(`button-${index + 1}`);
                    }}
                    data-filter={t.filter}
                    className={"filter-button clear-button"}
                  >
                    {t.name}
                  </button>
                );
              })}
          </div>
        ) : null}
        {projects.length > 1 ? (
          <div className="projects-grid">
            {projects.length > 0 &&
              projects.map((project) => {
                const technologies = project.topics;
                classFunction(technologies);
                console.log(technologies.includes(selectedFilter));
                if (selectedFilter == "") {
                  return (
                    <div
                      key={project.url}
                      className={classFunction(technologies)}
                    >
                      <a target="_blank" href={project.url}>
                        <img
                          style={{ height: "350px", height: "250px" }}
                          src={` https://raw.githubusercontent.com/Kartik18g/${project.name}/master/${project.name}.png`}
                          alt=""
                          className="project-image"
                        />
                      </a>
                      <h2 className="project-title">{project.name}</h2>
                      <div className="badges">
                        {technologies &&
                          technologies.map((t) => {
                            return <span>{t}</span>;
                          })}
                      </div>
                      <div key={project.url} className="child">
                        <h3 className="about">About</h3>
                        <div className="description">{project.description}</div>
                        <div className="buttons">
                          <div style={{ margin: "5px" }}>
                            <GitHubButton
                              data-size={"large"}
                              title={"view"}
                              data-color-scheme={"dark"}
                              href={`https://github.com/PriyaBihani`}
                            >
                              Follow
                            </GitHubButton>
                          </div>
                          <div style={{ margin: "5px" }}>
                            <GitHubButton
                              title={"octicon-eye"}
                              data-size={"large"}
                              data-color-scheme={"dark"}
                              data-icon={"octicon-eye"}
                              href={`https://github.com/kartik18g/${project.name}`}
                            >
                              View
                            </GitHubButton>
                          </div>
                          <div style={{ margin: "5px" }}>
                            <GitHubButton
                              data-size={"large"}
                              title={"octicon-star"}
                              data-color-scheme={"dark"}
                              data-icon={"octicon-star"}
                              href={`https://github.com/kartik18g/${project.name}`}
                            >
                              Star
                            </GitHubButton>
                          </div>
                          <div style={{ margin: "5px" }}>
                            <GitHubButton
                              title={"octicon-heart"}
                              data-size={"large"}
                              data-color-scheme={"dark"}
                              data-icon={"octicon-heart"}
                              href={`https://github.com/sponsors/kartik18g`}
                            >
                              Sponsor
                            </GitHubButton>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                } else if (technologies.includes(selectedFilter)) {
                  return (
                    <div
                      key={project.name}
                      className={classFunction(technologies)}
                    >
                      <a target="_blank" href={project.url}>
                        <img
                          style={{ height: "350px", height: "250px" }}
                          src={` https://raw.githubusercontent.com/PriyaBihani/${project.name}/master/${project.name}.png`}
                          alt=""
                          className="project-image"
                        />
                      </a>
                      <h2 className="project-title">{project.name}</h2>
                      <div className="badges">
                        {technologies &&
                          technologies.map((t) => {
                            return <span>{t}</span>;
                          })}
                      </div>
                      <div key={project.url} className="child">
                        <h3 className="about">About</h3>
                        <div className="description">{project.description}</div>
                        <div className="buttons">
                          <div style={{ margin: "5px" }}>
                            <GitHubButton
                              data-size={"large"}
                              title={"view"}
                              data-color-scheme={"dark"}
                              href={`https://github.com/PriyaBihani`}
                            >
                              Follow
                            </GitHubButton>
                          </div>
                          <div style={{ margin: "5px" }}>
                            <GitHubButton
                              title={"octicon-eye"}
                              data-size={"large"}
                              data-color-scheme={"dark"}
                              data-icon={"octicon-eye"}
                              href={`https://github.com/PriyaBihani/${project.name}`}
                            >
                              View
                            </GitHubButton>
                          </div>
                          <div style={{ margin: "5px" }}>
                            <GitHubButton
                              data-size={"large"}
                              title={"octicon-star"}
                              data-color-scheme={"dark"}
                              data-icon={"octicon-star"}
                              href={`https://github.com/PriyaBihani/${project.name}`}
                            >
                              Star
                            </GitHubButton>
                          </div>
                          <div style={{ margin: "5px" }}>
                            <GitHubButton
                              title={"octicon-heart"}
                              data-size={"large"}
                              data-color-scheme={"dark"}
                              data-icon={"octicon-heart"}
                              href={`https://github.com/sponsors/PriyaBihani`}
                            >
                              Sponsor
                            </GitHubButton>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                } else {
                  return null;
                }
              })}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default MiniProjects;
